module.exports = __webpack_public_path__ + "img/popular2.2d4232f3.png";